// extracted by mini-css-extract-plugin
export default {"section-title":"EventSwiper_section-title__aT+c2","swiper-container":"EventSwiper_swiper-container__GTS7S","swiper-slide":"EventSwiper_swiper-slide__4Xig2"};